module.exports = __webpack_public_path__ + "img/erasmus_plus_deutschland.64b70678.png";